import { ICheck, ICustomerData, RootState } from '@checkout/state';
import { partition } from 'lodash';
import { Component, ComponentClass, Fragment } from 'react';
import React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { MembershipHeader, MessageBox, Section } from '../../presentational';
import { ICheckoutContextConfig } from './../../../config/contextCheckoutConfig.d';
import messages from './../../../i18n/base-en';
import { customerClubFetchRequest } from './../../../reducers/checkout';
import * as Styles from './ChecksList.scss';

const moment = require('moment');

interface IOwnProps {
  checkoutContextConfig: ICheckoutContextConfig;
}

interface IConnectedProps {
  customerClubData: ICustomerData;
}

interface IConnectetDispatchProps {
  customerClubFetchRequest: typeof customerClubFetchRequest;
}

type Props = IOwnProps & IConnectedProps & IConnectetDispatchProps & InjectedIntlProps;

class ChecksList extends Component<Props, {}> {

  componentDidMount() {
    const { checkoutContextConfig, customerClubFetchRequest: fetchCustomerClubData } = this.props;

    if (checkoutContextConfig.modules.membership.customerClubFields.isEnabled) {
      fetchCustomerClubData();
    }
  }

  splitChecks = (checks: ICheck[]) => {
    const today = moment(moment());
    return partition(checks, (check: ICheck) => (today.isSameOrBefore(check.validThru) && today.isSameOrBefore(check.redeemDate)));
  }

  renderCheck = (checkItem: ICheck, isUsed: boolean) => {
    const { intl } = this.props;
    const { formatMessage } = intl;
    const validThru = checkItem.validThru && new Date(checkItem.validThru).toLocaleDateString();
    const redeemDate = checkItem.redeemDate && new Date(checkItem.redeemDate).toLocaleDateString();

    return (
      <div key={checkItem.barcode} className={Styles.checkItem}>
        <div className={Styles.block}>
          <div className={Styles.bold}>
            <span className={Styles.labelBig}>
              {formatMessage(messages.membership_check_voucher_code_label)}
            </span>
            <span>{checkItem.barcode}</span>
          </div>
          <div>
            <span className={Styles.labelBig}>
              {formatMessage(messages.membership_check_discount_label)}
            </span>
            <span>{checkItem.value}</span>
          </div>
        </div>
        <div className={Styles.block}>
          <small className={Styles.detail}>
            <Fragment>
              <span className={Styles.labelSmall}>
                {isUsed ? formatMessage(messages.membership_check_data_used_label) : formatMessage(messages.membership_check_data_valid_label)}
              </span>
              {isUsed ? redeemDate : validThru}
            </Fragment>
          </small>
        </div>
      </div>
    );
  }

  render() {
    const { intl, customerClubData } = this.props;
    const { formatMessage } = intl;
    const { customerClubFields } = customerClubData;
    const checksList = customerClubFields && customerClubFields.checks && customerClubFields.checks.list ? customerClubFields.checks.list : [];
    const [available = [], used = []] = this.splitChecks(checksList);

    return (
      <div className={Styles.wrapper}>
        <MembershipHeader subTitle={formatMessage(messages.membership_checks_subtitle)} />
        {customerClubData && customerClubFields && (
          <div className={Styles.inner}>
            <Section>
              <div className={Styles.points}>
                <span>{formatMessage(messages.membership_points_balance_label)}</span>
                <span>{customerClubFields.bonus}</span>
              </div>
            </Section>
            {checksList.length === 0 && (
              <MessageBox
                textAlign="center"
                type="info"
                message={formatMessage(messages.membership_no_checks_message)}
              />
            )}
            {checksList.length > 0 && available.length > 0 && (
              <Fragment>
                <MembershipHeader title={formatMessage(messages.membership_available_checks)} />
                <div>
                  {available && available.length > 0 && available.map((checkItem: ICheck) => this.renderCheck(checkItem, false))}
                </div>
              </Fragment>
            )}
            {checksList.length > 0 && used.length > 0 && (
              <Fragment>
                <MembershipHeader title={formatMessage(messages.membership_used_checks)} />
                <div>
                  {used && used.length > 0 && used.map((checkItem: ICheck) => this.renderCheck(checkItem, true))}
                </div>
              </Fragment>
            )}
          </div>

        )}
      </div>
    );
  }
}

export default compose<ComponentClass<IOwnProps>>(
  injectIntl,
  connect<IConnectedProps, {}>(
    (state: RootState) => ({
      customerClubData: state.checkout.customerClubData,
    }),
    {
      customerClubFetchRequest,
    },
  )
)(ChecksList);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/container/ChecksList/ChecksList.tsx